"use strict";
// ================================================================
// v2/theme/types.ts
// theme.palette.v2 に載るカラー + 合成済み box-shadow 文字列の型。
// MUI Palette 拡張 (utoniq-ui/@type/mui.d.ts, utoniq-app/types/mui.ts) から参照される。
// ================================================================
Object.defineProperty(exports, "__esModule", { value: true });
